import { useState, useEffect } from 'react';
import { fetchProductPrice } from '../lib/shopify-storefront-clean';

// Fallback prices if Shopify is not available
const FALLBACK_PRICES = {
  'rush': 48.99,
  'synaptiq': 48.99,
  'vitra': 58.99
};

export function useShopifyPrice(productId) {
  const [priceData, setPriceData] = useState({
    price: null,
    currencyCode: 'USD',
    variantId: null,
    available: true,
    loading: true,
    error: null
  });

  useEffect(() => {
    let mounted = true;

    async function loadPrice() {
      try {
        setPriceData(prev => ({ ...prev, loading: true, error: null }));
        
        const data = await fetchProductPrice(productId);
        
        if (mounted) {
          if (data) {
            // Shopify data available
            setPriceData({
              price: data.price,
              currencyCode: data.currencyCode,
              variantId: data.variantId,
              available: data.available,
              loading: false,
              error: null
            });
          } else {
            // Fallback to local prices
            setPriceData({
              price: FALLBACK_PRICES[productId] || 49.99,
              currencyCode: 'USD',
              variantId: `local-${productId}`,
              available: true,
              loading: false,
              error: 'Using local price - Products not accessible via Storefront API'
            });
          }
        }
        } catch (error) {
          // Use fallback prices on error
          setPriceData({
            price: FALLBACK_PRICES[productId] || 49.99,
            currencyCode: 'USD',
            variantId: `local-${productId}`,
            available: true,
            loading: false,
            error: `Shopify ACCESS_DENIED - using fallback price`
          });
        }
    }

    if (productId) {
      loadPrice();
    }

    return () => {
      mounted = false;
    };
  }, [productId]);

  return priceData;
}